import { useCallback, useEffect, useState } from 'react'

/** Hook that manages open/close state for the command palette via ⌘K / Ctrl+K. */
export function useCommandPalette(): {
  open: boolean
  setOpen: (value: boolean) => void
  onClose: () => void
} {
  const [open, setOpen] = useState(false)

  const onClose = useCallback((): void => {
    setOpen(false)
  }, [])

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent): void => {
      // ⌘K on Mac, Ctrl+K on Windows/Linux
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault()
        e.stopPropagation()
        setOpen(prev => !prev)
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [])

  return { open, setOpen, onClose }
}
